import { render, staticRenderFns } from "./applyForRecord.vue?vue&type=template&id=af9435d0&scoped=true&"
import script from "./applyForRecord.vue?vue&type=script&lang=js&"
export * from "./applyForRecord.vue?vue&type=script&lang=js&"
import style0 from "./applyForRecord.vue?vue&type=style&index=0&id=af9435d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9435d0",
  null
  
)

export default component.exports